import React from "react"
import { Section, OrderedListContent } from "@alexanderathoodly/ui-library"
import { BlockFooter } from "../blockfooter"
import { CommonBlockProps } from "../types"
import { getIconPath } from "../../helpers/getIconPath"

export interface ProcessProps extends CommonBlockProps {
    template: "process"
    illustration: string
    legend: {
        text: string
        icon: string
    }
    elements: {
        heading: string
        description: string
    }[]
}

const Process = ({
    id,
    color,
    icon = "destinations",
    label,
    headline,
    illustration,
    legend,
    elements = [],
    footertext,
    buttons,
    ...rest
}: ProcessProps): JSX.Element => {
    return (
        <Section
            id={id || undefined}
            className="process-section"
            shape="shape2"
            backgroundColor={color}
            icon={getIconPath(icon)}
            label={label}
            headline={headline}
            {...rest}
        >
            <OrderedListContent
                illustration={illustration}
                legend={legend.text}
                legendIcon={getIconPath(legend.icon)}
                elements={elements}
            />
            <BlockFooter footertext={footertext} buttons={buttons} position={headline} />
        </Section>
    )
}

export { Process }
